/**
 * Protokoll-Reiter im PB-Drawer — welche Aktionen dort gezeigt werden.
 *
 * Der Reiter soll nachvollziehbar machen, „wer wann angerufen hat und ob der
 * Kunde erreicht wurde" sowie welche E-Mails rausgegangen sind. Das
 * Aktionsprotokoll loggt über die Middleware aber JEDEN schreibenden
 * v2-Request (action `create`/`update`/`delete`) — ungefiltert würden die
 * paar relevanten Einträge darin untergehen.
 *
 * Der Filter nutzt die Präfix-Syntax von `GET /v2/admin/activity-protocol`
 * (`action=a,b,c*`, siehe ActivityProtocolController::applyActionFilter).
 *
 * Aktions-Namen (Stand 21.09.2026):
 *   3cx_call_*                — Anrufe, Status im Suffix (answered/missed/…),
 *                               inkl. 3cx_call_transcribed (RecordingWorkQueue)
 *   mail_sent / mail_failed   — manuell versendete E-Mail (Vorlage via
 *                               BrevoMailer oder MS Graph). Ein Name für beide
 *                               Versandwege — der Vorgang ist derselbe.
 *   stage_action_email_*      — automatische Stage-Aktion (PhaseActionService)
 *   docusign_envelope_sent    — Vertragsversand per DocuSign
 *   wiedervorlage_*           — Wiedervorlage gesetzt/geändert/entfernt
 */
export const DRAWER_PROTOKOLL_ACTION_LIST = [
  '3cx_call_*',
  'mail_sent',
  'mail_failed',
  'stage_action_email_*',
  'docusign_envelope_sent',
  'wiedervorlage_*',
] as const;

/** Kommagetrennter Wert für den `action`-Query-Parameter. */
export const DRAWER_PROTOKOLL_ACTIONS = DRAWER_PROTOKOLL_ACTION_LIST.join(',');
